<div class="powerbi-report">
  <ng-container *ngIf="isLoaded">
    <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
  </ng-container>

  <div *ngIf="accessDenied" class="access-denied">
    <mat-icon class="access-denied-icon">lock</mat-icon>
    <h2>Access Denied</h2>
    <p>{{ accessDeniedMessage }}</p>
  </div>

  <div #reportContainer class="report-container" [style.display]="isLoaded || accessDenied ? 'none' : 'block'"></div>
</div>
